import { UserInfoState } from "./rootReducerTypes";
import { EndFetchUserInfoAction, END_FETCH_USERINFO, InitFetchUserInfoAction, INIT_FETCH_USERINFO, UpdateUserInfoAction, UpdateUserInfoActionPayload, UPDATE_USERINFO, UserInfoActionTypes } from "./userInfoActionAnReducerTypes";


export function updateUserInformation(userInfoPayload: UpdateUserInfoActionPayload): UpdateUserInfoAction {
    return {
        type: UPDATE_USERINFO,
        updateUserInfoActionPayload: userInfoPayload,
    };
}

export function initalizeFetchUserInformation(): InitFetchUserInfoAction {
    return {
        type: INIT_FETCH_USERINFO
    };
}

export function endFetchUserInformation(): EndFetchUserInfoAction {
    return {
        type: END_FETCH_USERINFO
    };
}

export default function userInfoReducer(state: UserInfoState = initialState, action: UserInfoActionTypes): UserInfoState {
    switch (action.type) {
        case 'UPDATE_USERINFO':
            return {
                ...state,
                userInformation: action.updateUserInfoActionPayload.userInformation,
                isLoadingUserInformation: false
            };
        case 'INIT_FETCH_USERINFO':
            return {
                ...state,
                isLoadingUserInformation: true
            };
        case 'END_FETCH_USERINFO':
            return {
                ...state,
                isLoadingUserInformation: false
            };
        default:
            return state;
    }
}

export const initialState: UserInfoState = {
    userInformation: {
        userPermissions: {
            '': []
        },
        userSettings: {
            '': []
        },
        license: {
            '': []
        },
        isCustomerPortalSuperAdmin: false,
        employeeId: null,
        identityId: null,
        name: ''
    },
    isLoadingUserInformation: false
};